import { Component, OnInit, Inject } from '@angular/core';
//import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogModel } from 'src/app/core/models/view-model';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss'],
})
export class FileUploadDialogComponent implements OnInit {
  fileToUpload: any | null;

  constructor(@Inject(MAT_DIALOG_DATA) public alertDialog: AlertDialogModel) {}

  ngOnInit(): void {}

  handleFileInput(files: FileList): void {
    this.fileToUpload = files.item(0);
  }
}
